import { combineReducers } from "redux";
import listBusinessManage from './listBusinessManage'


const businessReducer = combineReducers({
    listBusinessManage
})

export default businessReducer;